import { WatchQueryFetchPolicy } from "@apollo/client";

import { useFetchCurrentAccountQuery } from "src/entities/account/document.gen";

type Props = {
  onCompleted?: (
    account: NonNullable<
      NonNullable<
        NonNullable<ReturnType<typeof useFetchCurrentAccountQuery>>["data"]
      >["currentAccount"]
    >,
  ) => void;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
  clinicId?: string;
};

export const useCurrentAccount = (props?: Props) => {
  const { data, loading, refetch, error } = useFetchCurrentAccountQuery(
    !props?.skip
      ? {
          variables: {
            clinicId: props?.clinicId,
            withClinicId: !!props?.clinicId,
          },
          fetchPolicy: props?.fetchPolicy,
          onCompleted: (data) => {
            !!props?.onCompleted && !!data.currentAccount && props.onCompleted(data.currentAccount);
          },
        }
      : { skip: true },
  );

  return {
    currentAccount: data?.currentAccount,
    loading,
    refetch,
    error,
  };
};
